import { useQuery } from '@tanstack/react-query';
import { configApi } from '../../configApi';

interface ICandidateProofLocation {
  candidate_address: string;
  candidate_name: string;
  cellphone: string;
  cpf: string;
  date_of_birth: string;
  document_identifier: string;
  document_number: string;
  document_type: string;
  document_type_flag: string;
  is_foreign: boolean;
  passport_number: number;
}

interface ICandidateAllocation {
  details: string;
  gate_closing_time: string;
  gate_opening_time: string;
  test_date: string;
  test_hour: string;
  test_room_name: string;
  test_site_address: string;
  test_site_name: string;
}

interface IExamSchedule {
  duration_minutes: number;
  exam_schedule_date: string;
  exam_schedule_end_time: string;
  exam_schedule_id: string;
  exam_schedule_room_name: string;
  exam_schedule_start_time: string;
  exam_type: string;
  instructions: string;
}

export interface IProofLocationSpecialCompetitionProps {
  candidate: ICandidateProofLocation;
  candidate_allocation: ICandidateAllocation;
  exam_schedule: IExamSchedule;
  first_vacancy: string;
  has_exam_schedule: boolean;
  id: string;
  is_cultural_house: boolean;
  notice_name: string;
  registration_code: number;
  second_vacancy: string;
  step_title: string;
  text_alert_of_convocation_card: string;
  candidate_registration_card: string;
}

interface IParams {
  stepId: string;
  registrationId: string;
}

const GetProofLocationSpecialResultCompetition = async (params: IParams) => {
  const response = await configApi.get<IProofLocationSpecialCompetitionProps>(
    `registration/test-admission-card-step/`,
    {
      params: {
        registration_id: params.registrationId,
        allocation_id: params.stepId,
      },
    },
  );
  return response.data;
};

export const useGetProofLocationSpecialResultCompetition = (params: IParams) => {
  return useQuery({
    queryKey: ['Get_Proof_Location_special_result_competition', params.registrationId, params.stepId],
    queryFn: () => GetProofLocationSpecialResultCompetition(params),
    refetchOnWindowFocus: false,
  });
};
